// extracted by mini-css-extract-plugin
export default {"icon":"ContactDetail_icon__1i30g","pfp":"ContactDetail_pfp__xB-jh"};